import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/privacy-policy/page.tsx");
